'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import DynamicLogo from '@components/DynamicLogo';
import DynamicHideBlock from '@components/DynamicHideBlock';
import cn from './style.module.scss';
export default function EastvaleFooter(props: MarketingPageComponentProps) {
  const footerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'footer' && section.enabled
  );
  if (!footerSection) return null;
  return (
    <Stack component="footer" className={cn.eastvaleFooterWrapper}>
      <Box className={cn.eastvaleFooterInner}>
        <Box className={cn.eastvaleFooterBlock}>
          <Box className={cn.eastvaleFooterDevoloped}>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(footerSection?.eastvaleFooterDevelopedBy)}
            </ParallaxText>
          </Box>
          <Box className={cn.eastvaleFooterSodic}>
            <DynamicHideBlock data={footerSection?.eastvaleFooterSodicLogo}>
              <Box component="picture" className={cn.eastvaleFooterElement}>
                <DynamicLogo
                  logoImage={footerSection?.eastvaleFooterSodicLogo}
                  alt={'Ogami Logo'}
                />
              </Box>
            </DynamicHideBlock>
          </Box>
          <Box className={cn.eastvaleFooterAldar}>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(footerSection?.eastvaleFooterSodicAldar)}
            </ParallaxText>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
